import { render } from "./ReviewListScreen.vue?vue&type=template&id=3d94a9fa&scoped=true"
import script from "./ReviewListScreen.vue?vue&type=script&lang=js"
export * from "./ReviewListScreen.vue?vue&type=script&lang=js"

import "./ReviewListScreen.vue?vue&type=style&index=0&id=3d94a9fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d94a9fa"]])

export default __exports__